import _ from "lodash";
import React from "react";
import EventRow from "../EventRow/EventRow";
import { PaperClipOutlined } from "@toddle-edu/ds-icons";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
} from "../../modules/Utils";
import { connect } from "react-redux";
import classes from "./Attachments.scss";
import AttachmentList from "AppComponents/Attachment/AttachmentList";
import CreateDropDown from "AppComponents/Attachment/CreateDropDown";
import { nanoid } from "nanoid";

const DROP_DOWN_OPTIONS = [
  {
    key: "upload_device",
    label: "common:upload_file_from_device",
  },
  {
    key: "add_google_drive",
    label: "common:google_drive",
  },
  {
    key: "add_one_drive",
    label: "common:one_drive",
  },
  {
    key: "add_link",
    label: "common:add_link",
  },
];

const styles = {
  attachmentContainerStyle: {
    gap: "8px",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
  },
  iconButtonStyles: { width: "36px" },
};

const fullScreenStyles = {
  attachmentContainerStyle: {
    gap: "8px",
    gridTemplateColumns: "repeat(3, minmax(180px, 1fr))",
    "margin-left": " -156px",
    width: "calc(100% + 156px)",
  },
};

const EventAttachments = props => {
  const {
    attachments,
    parentId,
    parentType = "CIRCULAR",
    setEventAttachments,
    testId = "event-attachments",
    isFullScreenMode = false,
    iconButtonType = "outlined",
  } = props;

  // Ref tracks the latest attachments synchronously to prevent stale closure
  // issues when multiple files are uploaded rapidly before React re-renders.
  const attachmentsRef = React.useRef(attachments);
  attachmentsRef.current = attachments;

  const addAttachment = async params => {
    if (_.isEmpty(params)) return;
    const attachment = _.first(params);

    // nanoid generates a unique ID for each attachment, avoiding ID collisions
    // when rapid uploads trigger multiple addAttachment calls before re-render.
    attachment.id = nanoid();

    const updatedAttachments = [...attachmentsRef.current, attachment];
    attachmentsRef.current = updatedAttachments;
    setEventAttachments(updatedAttachments);
  };

  const onDeleteAttachment = async attachment => {
    const updatedAttachments = attachments.filter(
      item => _.get(item, "id") !== _.get(attachment, "attachmentId")
    );
    setEventAttachments(updatedAttachments);
  };

  return (
    <div className={classes.attachmentsContainer}>
      <CreateDropDown
        testId={testId}
        dsVersion="2.0"
        dropDownOptions={DROP_DOWN_OPTIONS}
        isShowIconsInBar={true}
        showV2Icons={true}
        reduceSpacingBetweenIcons={true}
        iconButtonVariantV2="neutral"
        iconButtonType={iconButtonType}
        parentId={parentId}
        parentType={parentType}
        addAttachment={addAttachment}
        audioRecorderV5Position={{ y: 707 }}
        iconButtonStyles={styles.iconButtonStyles}
        validateOnUserInput={true}
      />
      <div
        className={
          _.isEmpty(attachments) ? "" : classes.attachmentListContainer
        }
      >
        {isFullScreenMode ? (
          <AttachmentList
            name="attachments"
            value={attachments}
            cardType="design-media-card"
            attachmentContainerStyle={fullScreenStyles.attachmentContainerStyle}
            showCreateDropdown={false}
            showWaveformPlayer={true}
            mediaCardClasses={classes.mediaCard}
            isCustomClassForAudioWaveform={true}
            showDeleteForSelfInViewMode={true}
            showIconButton={true}
            isPrintEnabled={false}
            mode="edit"
            testId={testId}
            onDeleteAttachmentCallback={onDeleteAttachment}
          />
        ) : (
          <AttachmentList
            dsVersion="2.0"
            name="attachments"
            value={attachments}
            cardType="design-media-card"
            mediaCardSize="small"
            attachmentMode={"view"}
            dropdownIconButtonSize="small"
            showCreateDropdown={false}
            showDeleteForSelfInViewMode={true}
            isShowIconsInBar={true}
            showV2Icons={true}
            isPrintEnabled={true}
            mode={"edit"}
            showRenameAttachmentOption={false}
            onDeleteAttachmentCallback={onDeleteAttachment}
            attachmentContainerStyle={_.get(
              styles,
              "attachmentContainerStyle",
              {}
            )}
          />
        )}
      </div>
    </div>
  );
};

const Attachments = props => {
  const {
    eventModalV2,
    updateEventModalV2,
    isFullScreenMode,
    iconButtonType,
  } = props;
  const setEventAttachments = setValue("attachments", updateEventModalV2);
  return (
    <EventRow
      label="common:attachments"
      labelClass={classes.reminderLabel}
      className={classes.reminderRowContainer}
      icon={<PaperClipOutlined variant="subtle" />}
      renderComponent={() => (
        <EventAttachments
          setEventAttachments={setEventAttachments}
          attachments={eventModalV2?.attachments || []}
          parentId={null}
          iconButtonType={iconButtonType}
          isFullScreenMode={isFullScreenMode}
        />
      )}
    />
  );
};

export default connect(mapStateToProps, {
  ...mapActionCreators,
})(Attachments);
